type EnvProperties = {
  apiEndpoint: string;
  apiBasePath: string;
  siteOrigin: string;
};

export type EnvConfig = {
  isDev: boolean;
} & EnvProperties;

const isDev = process.env.NODE_ENV === 'development';

export const envConfig: EnvConfig = {
  siteOrigin: process.env.NEXT_PUBLIC_SITE_URL!,
  apiEndpoint: process.env.NEXT_PUBLIC_API_ENDPOINT!,
  apiBasePath: process.env.NEXT_PUBLIC_BASE_URL!,
  isDev,
};
